enum RequestType {
  Post = "POST",
  Put = "PUT",
  Patch = "PATCH",
  Get = "GET",
  Delete = "DELETE",
}

export default RequestType;
